import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDashboardStore } from '../../stores/Layout/dashboard';

const Request = () => {
  const { t } = useTranslation();
  const { requestsInfo } = useDashboardStore();
  const navigate = useNavigate();
  
  return (
    <div className="w-full sm:h-full flex flex-col justify-start items-start p-3 ">
      {/* Requetes expirées */}
      <div className="flex items-center gap-4">
        <div className="p-3 bg-yellow-trio rounded-xl">
          <svg className="w-6 h-6 text-grey-trio" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
        <div>
          <h1 className="text-xl font-bold text-gray-700 font-K2D">
            {t("dashboard.requestsTitle")}
          </h1>
          <p className="text-sm sm:text-md text-gray-600 mt-1">
            {t("dashboard.requestsSubtitle")}
          </p>
        </div>
      </div>
      <div className="w-full h-full flex flex-col justify-start items-center bg-white mb-4 p-2 sm:p-4 gap-3 sm:gap-4 overflow-y-auto">
        {requestsInfo?.length > 0 ? requestsInfo.map((item: any) => (
          <button 
            key={item.id} 
            className="w-full h-auto flex flex-col justify-start items-start border border-gray-100 rounded-xl bg-white shadow-xl p-2 sm:p-3 cursor-pointer" 
            onClick={() => item.isCustomer ? navigate(`/customer/${item.idCustomer}/missions/${item.idMission}/requests`)
            : navigate(`/partner/${item.idPartner}/customers/${item.idCustomer}/missions/${item.idMission}/requests`)}
            >
            <div className="text-red-500 w-auto min-w-28 border border-red-500 rounded-full text-sm px-2 py-1 text-center mb-2 whitespace-nowrap">{t("dashboard.expiresSoon")}</div>
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center w-full gap-2">
              <h1 className="text-base sm:text-lg lg:text-xl font-bold text-gray-700 font-K2D ml-1">
                {item.namePartner}
              </h1>
              <p className="hidden 2xl:block text-xs sm:text-sm text-gray-600">{t("dashboard.requestsCount")} : <span className="font-bold">{item.docRequestCount}</span></p>
            </div>
            <p className="text-xs sm:text-sm text-gray-600 italic ml-1">{t("dashboard.client")} : <span className="font-bold">{item.nameCustomer}</span></p>
            <p className="text-xs sm:text-sm text-gray-600 italic ml-1">{t("dashboard.mission")} : <span className="font-bold">{item.nameMission}</span></p>
          </button>
        )) : 
          <div className="text-center 2xl:py-12">
            <div className="hidden 2xl:flex w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-full items-center justify-center">
              <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">{t("dashboard.noRequestTitle")}</h3>
            <p className="text-gray-500">{t("dashboard.noRequestText")}</p>
          </div>
        }
      </div>
    </div>
  )
}

export default Request
